import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { IonAlert, setupIonicReact } from "@ionic/react";
import { Preferences } from "@capacitor/preferences";
import "../../styles/config.css"; // 👈 importa el css
import { setTourFlag } from "../../api/onboarding";

// Extend the Window interface to include 'Capacitor' and 'cordova'
declare global {
  interface Window {
    Capacitor?: any;
    cordova?: any;
  }
}

setupIonicReact({ mode: "md" });

type Props = {
  onLogout: () => void;
  onDeleteAccount: (password: string) => void; // 👈 ahora recibe la contraseña
  onChangePasswordRequested: () => void;
};

export default function ConfigurationPage({
  onLogout,
  onDeleteAccount,
  onChangePasswordRequested,
}: Props) {
  const [showLogout, setShowLogout] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const MenuItem = ({
    title,
    onClick,
  }: {
    title: string;
    onClick: () => void;
  }) => (
    <div className="config-item" onClick={onClick}>
      <span>{title}</span>
      <ChevronRight size={20} />
    </div>
  );

  return (
    <div className="config-page">
      <h2 className="config-title">Configuración</h2>

      <div className="config-menu">
        <MenuItem title="Cerrar sesión" onClick={() => setShowLogout(true)} />
        <MenuItem title="Eliminar cuenta" onClick={() => setShowDelete(true)} />
        <MenuItem
          title="Cambiar contraseña"
          onClick={onChangePasswordRequested}
        />
        <MenuItem
          title="Ver tutorial de nuevo"
          onClick={async () => {
            await setTourFlag(false);
            // Redirige y fuerza recarga en web y móviles
            if (window?.cordova || window?.Capacitor) {
              window.location.replace("/client");
              setTimeout(() => window.location.reload(), 300);
            } else {
              window.location.href = "/client";
              setTimeout(() => window.location.reload(), 300);
            }
          }}
        />
      </div>

      {/* Confirm dialogs */}
      <IonAlert
        mode="md"
        isOpen={showLogout}
        header="Cerrar sesión"
        message="¿Estás seguro de que quieres cerrar la sesión?"
        buttons={[
          { text: "No", role: "cancel", handler: () => setShowLogout(false) },
          { text: "Sí", role: "destructive", handler: onLogout },
        ]}
        onDidDismiss={() => setShowLogout(false)}
      />

      <IonAlert
        mode="md"
        isOpen={showDelete}
        header="Eliminar cuenta"
        message="Introduce tu contraseña para confirmar:"
        inputs={[
          {
            name: "password",
            type: "password",
            placeholder: "Contraseña",
          },
        ]}
        buttons={[
          {
            text: "Cancelar",
            role: "cancel",
            handler: () => setShowDelete(false),
          },
          {
            text: "Eliminar",
            role: "destructive",
            handler: (data) => {
              const password = data.password;
              if (password && password.trim() !== "") {
                onDeleteAccount(password);
              } else {
                // opcional: podrías mostrar un error si está vacío
                console.warn("❌ No se introdujo contraseña");
                return false; // evita que se cierre el alert
              }
            },
          },
        ]}
        onDidDismiss={() => setShowDelete(false)}
      />
    </div>
  );
}
